/**
 * Round to defined decimal places (only if necessary).
 * Round half away from zero (is the default behaviour of rounding).
 *
 * @param {number} number
 * @param {number} decimalPlaces
 * @returns {number}
 * @link https://stackoverflow.com/a/11832950/5394518
 * @link https://en.wikipedia.org/wiki/Rounding#Round_half_away_from_zero
 */
export const round = (number, decimalPlaces = 2) => {
  const precision = 10 ** decimalPlaces;
  const x = (number * precision) * (1 + Number.EPSILON);

  return Math.round(x) / precision;
};
